import React, { useEffect, useState } from "react";
import moment from 'moment';
import Graph from '../../components/Graph';
import { useToasts } from 'react-toast-notifications';
import { API } from 'aws-amplify';
import Table from "react-bootstrap/esm/Table";

const qindex1 = require('../../assets/images/qindex1.png');
const qindex2 = require('../../assets/images/qindex2.png');
const qindex3 = require('../../assets/images/qindex3.png');
const qindex4 = require('../../assets/images/qindex4.png');
const qindex5 = require('../../assets/images/qindex5.png');
const qindex6 = require('../../assets/images/qindex6.png');

const AirQuality = (props) => {
    const { addToast } = useToasts();
    // const [dataCO, setDataCO] = useState({});
    const [dataNO, setDataNO] = useState({});
    const [dataOX, setDataOX] = useState({});
    const [dataSO, setDataSO] = useState({});
    // const [dataPM1, setDataPM1] = useState({});
    const [dataPM25, setDataPM25] = useState({});
    // const [dataPM4, setDataPM4] = useState({});
    const [dataPM10, setDataPM10] = useState({});
    const [dataTemp, setDataTemp] = useState({});
    const [dataHum, setDataHum] = useState({});

    const {
        asset,
        dateSel,
        dateSelTo,
        timeFrom,
        timeTo,
        params,
        isLoadingCounts,
        options,
        assetName
     } = props

     const sum = (arr) => arr.reduce((a, b) => a + b, 0);
     const count_non_zeros = (arr) => arr.reduce((a, b) => b > 0 ? a + 1 : a, 0);
     const avg_excluding_zeros = (arr) => {
        if (arr.length === 0) {
          return 0;
        }
        const non_zeros = count_non_zeros(arr);
        if (non_zeros === 0) {
          return 0;
        }
        return parseFloat((sum(arr) / non_zeros).toFixed(2));
      };

      const colorIndex = (val,i) => {
        // air quality colors
        const aq_colors = [
            '#509954',
            '#a0c958',
            '#e4cb45',
            '#f3bd41',
            '#f09235',
            '#da3322',
            '#819ca9'
         ]       
         // air quality max index level [O3, NO2, SO2, PM10, PM2.5] 
         const aq_limits = [
             [50, 100, 130, 240, 380, 800],
             [40, 90, 120, 230, 340, 1000],
             [100, 200, 350, 500, 750, 1250],
             [20, 40, 50, 100, 150, 1200],
             [10, 20, 25, 50, 75, 800],
         ]

         
         let color = aq_colors[6]

         if (val <= aq_limits[i][0])
                color = aq_colors[0];
         else if (val > aq_limits[i][0] && val <= aq_limits[i][1])
                color = aq_colors[1];
         else if (val > aq_limits[i][1] && val <= aq_limits[i][2])
                color = aq_colors[2];  
         else if (val > aq_limits[i][2] && val <= aq_limits[i][3])
                color = aq_colors[3];   
         else if (val > aq_limits[i][3] && val <= aq_limits[i][4])
                color = aq_colors[4]; 
         else if (val > aq_limits[i][4] && val <= aq_limits[i][5])
                color = aq_colors[5];  
         else    
                color = aq_colors[6]; 

         return color;

      }
    // Load counts
    // Fetch hourly counts filter by asset, date and time range
    useEffect(() => {
        const fetchCounts = async () => {
            const dtF = new Date(dateSel)
            const dtT = new Date(dateSelTo)

            const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
            const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
            let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

            const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
            const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
            let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();

            if (dateEnd >= dateStart){
                const filter = asset +'?start='+ dateStart +'&end='+ dateEnd

                let data = []
               
                // const dataSet = [];
                // const dataSet2 = [];
                const arrCO_A4 =[];
                const arrNO2_A43F =[];
                const arrOX_A431 =[];
                const arrPM_1p0 =[];
                const arrPM_2p5 =[];
                const arrPM_4p0 =[];
                const arrPM_10p0 =[];
                const arrSO2_A4 =[];
                const arrTemperature =[];
                const arrHumidity =[];

                await API.get('hourly_air_quality','/'+ filter, params)
                .then(resp => {
                    // console.log(resp)
                    data = resp

                    for (let hh = 0; hh < 24; hh++){
                        // console.log(data)
                        let dataHour = data.length>0 && data.filter(item => {
                            let aDate = moment(new Date(item.date_iso)).format('HH');
                            return parseInt(aDate) === hh;
                        })
                        
                        arrCO_A4.push((dataHour.length>0 && dataHour[0].CO_A4) || 0)
                        arrNO2_A43F.push((dataHour.length>0 && dataHour[0].NO2_A43F) || 0)
                        arrOX_A431.push((dataHour.length>0 && dataHour[0].OX_A431) || 0)
                        arrPM_1p0.push((dataHour.length>0 && dataHour[0].PM_1p0) || 0)
                        arrPM_2p5.push((dataHour.length>0 && dataHour[0].PM_2p5) || 0)
                        arrPM_4p0.push((dataHour.length>0 && dataHour[0].PM_4p0) || 0)
                        arrPM_10p0.push((dataHour.length>0 && dataHour[0].PM_10p0) || 0)
                        arrSO2_A4.push((dataHour.length>0 && dataHour[0].SO2_A4) || 0)
                        arrTemperature.push((dataHour.length>0 && dataHour[0].Temperature) || 0)
                        arrHumidity.push((dataHour.length>0 && dataHour[0].Humidity) || 0)

                    }
                    
                }).catch(error => {
                    console.log(error)
                    addToast('Error Loading Data', { appearance: 'error' });
                });

                // pollutant avg [O3, NO2, SO2, PM10, PM2.5] 
                const p_avg = [
                    avg_excluding_zeros(arrOX_A431),
                    avg_excluding_zeros(arrNO2_A43F),
                    avg_excluding_zeros(arrSO2_A4),
                    avg_excluding_zeros(arrPM_10p0),
                    avg_excluding_zeros(arrPM_2p5),
                    avg_excluding_zeros(arrTemperature),
                    avg_excluding_zeros(arrHumidity),
                ]

                // Carbon Monoxide (CO)
                // setDataCO({
                //     labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                //             ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                //             ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                //             ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                //             ],
                //     datasets: [{
                //         label: "CO",
                //         data: arrCO_A4,
                //         borderColor: colors[1 % colors.length],
                //         // stepped: true,
                //     }],                   
                // });


                // Nitrogen Dioxide Sensors (NO2)
                setDataNO({
                    labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                            ],
                    datasets: [{
                        label: "NO2",
                        data: arrNO2_A43F,
                        borderColor:  colorIndex(p_avg[1],1),
                    }],                  
                });
                // Ozone Sensors (O3)
                setDataOX({
                    labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                            ],
                    datasets: [{
                        label: "O3",
                        data: arrOX_A431,
                        borderColor:  colorIndex(p_avg[0],0),
                    }],                  
                });
                // Sulphur Dioxide Sensors (SO2)
                setDataSO({
                    labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                            ],
                    datasets: [{
                        label: "SO2",
                        data: arrSO2_A4,
                        borderColor:  colorIndex(p_avg[2],2),
                    }],                  
                });

                // Particulate matter (PM) less than 1 micron in size
                // setDataPM1({
                //     labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                //             ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                //             ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                //             ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                //             ],
                //     datasets: [{
                //         label: "PM1",
                //         data: arrPM_1p0,
                //         borderColor: colors[1 % colors.length],
                //     }],                  
                // });

                // Particulate matter (PM) less than 2.5 micron in size
                setDataPM25({
                    labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                            ],
                    datasets: [{
                        label: "PM2.5",
                        data: arrPM_2p5,
                        borderColor: colorIndex(p_avg[4],4),
                    }],                  
                });
                
                // Particulate matter (PM) less than 4 micron in size
                // setDataPM4({
                //     labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                //             ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                //             ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                //             ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                //             ],
                //     datasets: [{
                //         label: "PM4",
                //         data: arrPM_4p0,
                //         borderColor: colors[1 % colors.length],
                //     }],                  
                // });

                // Particulate matter (PM) less than 10 micron in size
                setDataPM10({
                    labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                            ],
                    datasets: [{
                        label: "PM10",
                        data: arrPM_10p0,
                        borderColor:  colorIndex(p_avg[3],3),
                    }],                  
                });

                // Temperature
                setDataTemp({
                    labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                            ],
                    datasets: [{
                        label: "Temperature",
                        data: arrTemperature,
                        borderColor:  'rgba(75, 192, 192, 1)',
                    }],                  
                });

                // Humidity
                setDataHum({
                    labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                            ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                            ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                            ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                            ],
                    datasets: [{
                        label: "Humidity",
                        data: arrHumidity,
                        borderColor:  'rgba(75, 192, 192, 1)',
                    }],                  
                });

            } else {
                addToast('Error incorrect dates', { appearance: 'error' });
            }
        }
        if (isLoadingCounts){
            fetchCounts();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isLoadingCounts ]);

        
    // Clear values
    useEffect(() => {
        if (assetName === ''){
            setDataNO({});
            setDataOX({});
            setDataSO({});
            setDataPM25({});
            setDataPM10({});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[assetName]);


return (
    <div className="row p-2">
        <div className="col-md-12">
        <h2 className="text-header">Air Quality</h2>
        <div className="text-description small pb-3">
        the Air Quality index is computed for five main pollutants:
        <ul>
        <li>Ozone (O3)</li>
        <li>Nitrogen Dioxide (NO2)</li>
        <li>Sulphur Dioxide (SO2)</li>
        <li>Fine particulate matter with a diameter smaller than 2.5 micrometers (PM2.5)</li>
        <li>Fine particulate matter with a diameter smaller than 10 micrometers (PM10)</li> 
        </ul>
        the index ranges from 1 (good) to 6 (extremely poor). For each pollutant, the index is calculated separately according to the concentrations; the higher the concentrations, the higher the index (see Table below for index levels). 
        The overall daily Air Quality index is the highest value of the overall hourly Air Quality index in the corresponding day
        </div>
        <div className="row">
            {/* <div className="col-md-6 p-2">
            {(dataCO.datasets && dataCO.datasets.length > 0)?
                <Graph
                title="Carbon Monoxide (CO)"
                type="line"
                data={dataCO}
                options={options}
                site={assetName}
                />
            :''}
            </div> */}
            <div className="col-md-6 p-2">
            {(dataTemp.datasets && dataTemp.datasets.length > 0)?
                <Graph
                title="Temperature (°C)"
                type="line"
                data={dataTemp}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            <div className="col-md-6 p-2">
            {(dataHum.datasets && dataHum.datasets.length > 0)?
                <Graph
                title="Humidity (%RH)"
                type="line"
                data={dataHum}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            <div className="col-md-6 p-2">
            {(dataNO.datasets && dataNO.datasets.length > 0)?
                <Graph
                title="Nitrogen Dioxide (NO2)"
                type="line"
                data={dataNO}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            <div className="col-md-6 p-2">
            {(dataOX.datasets && dataOX.datasets.length > 0)?
                <Graph
                title="Ozone (O3)"
                type="line"
                data={dataOX}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            <div className="col-md-6 p-2">
            {(dataSO.datasets && dataSO.datasets.length > 0)?
                <Graph
                title="Sulphur Dioxide (SO2)"
                type="line"
                data={dataSO}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            {/* <div className="col-md-6 p-2">
            {(dataPM1.datasets && dataPM1.datasets.length > 0)?
                <Graph
                title="Particulate Matter (PM) less than 1 micron"
                type="line"
                data={dataPM1}
                options={options}
                site={assetName}
                />
            :''}
            </div> */}
            <div className="col-md-6 p-2">
            {(dataPM25.datasets && dataPM25.datasets.length > 0)?
                <Graph
                title="Particulate Matter (PM) less than 2.5 micron"
                type="line"
                data={dataPM25}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            {/* <div className="col-md-6 p-2">
            {(dataPM4.datasets && dataPM4.datasets.length > 0)?
                <Graph
                title="Particulate Matter (PM) less than 4 micron"
                type="line"
                data={dataPM4}
                options={options}
                site={assetName}
                />
            :''}
            </div> */}
            <div className="col-md-6 p-2">
            {(dataPM10.datasets && dataPM10.datasets.length > 0)?
                <Graph
                title="Particulate Matter (PM) less than 10 micron"
                type="line"
                data={dataPM10}
                options={options}
                site={assetName}
                />
            :''}
            </div>
            <div className="col-md-6 p-2">
            <Table responsive bordered hover className="smaller text-nowrap p-0">
                <thead>
                    <tr>
                        <th className="text-center bg-dark text-light">POLLUTANT</th>
                        <th colSpan="6" className="text-center bg-dark text-light">INDEX LEVEL <br/>(based on pollutant concentrations in &micro;g/m3 )</th>
                    </tr>
                    <tr>
                        <th className="p-0 m-0 text-center"></th>
                        <th className="p-0 m-0 text-center"><img src={qindex1} width="50" alt=""/></th>
                        <th className="p-0 m-0 text-center"><img src={qindex2} width="50" alt="" /></th>
                        <th className="p-0 m-0 text-center"><img src={qindex3} width="50" alt="" /></th>
                        <th className="p-0 m-0 text-center"><img src={qindex4} width="50" alt="" /></th>
                        <th className="p-0 m-0 text-center"><img src={qindex5} width="50" alt="" /></th>
                        <th className="p-0 m-0 text-center"><img src={qindex6} width="50" alt="" /></th>
                    </tr>
                </thead>
                <tbody>
                    <tr  className="table-tr">
                        <td className="py-1 text-wrap">Ozone (O3)</td>
                        <td className="py-1 bg-aq1">0-50</td>
                        <td className="py-1 bg-aq2">50-100</td>
                        <td className="py-1 bg-aq3">100-130</td>
                        <td className="py-1 bg-aq4">130-240</td>
                        <td className="py-1 bg-aq5">240-380</td>
                        <td className="py-1 bg-aq6">380-800</td>
                    </tr>  
                    <tr  className="table-tr">
                        <td className="py-1 text-wrap">Nitrogen Dioxide (NO2)</td>
                        <td className="py-1 bg-aq1">0-40</td>
                        <td className="py-1 bg-aq2">40-90</td>
                        <td className="py-1 bg-aq3">90-120</td>
                        <td className="py-1 bg-aq4">120-230</td>
                        <td className="py-1 bg-aq5">230-340</td>
                        <td className="py-1 bg-aq6">340-1000</td>
                    </tr>     
                    <tr  className="table-tr">
                        <td className="py-1 text-wrap">Sulphur Dioxide (SO2)</td>
                        <td className="py-1 bg-aq1">0-100</td>
                        <td className="py-1 bg-aq2">100-200</td>
                        <td className="py-1 bg-aq3">200-350</td>
                        <td className="py-1 bg-aq4">350-500</td>
                        <td className="py-1 bg-aq5">500-750</td>
                        <td className="py-1 bg-aq6">750-1250</td>
                    </tr>   
                    <tr  className="table-tr">
                        <td className="py-1 text-wrap">Particulate less than 10&micro;u</td>
                        <td className="py-1 bg-aq1">0-20</td>
                        <td className="py-1 bg-aq2">20-40</td>
                        <td className="py-1 bg-aq3">40-50</td>
                        <td className="py-1 bg-aq4">50-100</td>
                        <td className="py-1 bg-aq5">150-1200</td>
                        <td className="py-1 bg-aq6">750-1250</td>
                    </tr>      
                    <tr  className="table-tr">
                        <td className="py-1 text-wrap">Particulate less than 2.5&micro;u</td>
                        <td className="py-1 bg-aq1">0-10</td>
                        <td className="py-1 bg-aq2">10-20</td>
                        <td className="py-1 bg-aq3">20-25</td>
                        <td className="py-1 bg-aq4">25-50</td>
                        <td className="py-1 bg-aq5">50-75</td>
                        <td className="py-1 bg-aq6">75-800</td>
                    </tr>       
                </tbody>
            </Table>
            </div>
        </div>
        </div>
    </div>
)}

export default AirQuality;